import React from 'react';
import { getEvaluationObject } from "./renderhelpers";
import UserSession from "../../Utils/UserSession";
import { withRouter } from "../../Helpers/withRouter";
var css = {
  "popularField": "oalp-11Hk3",
  "showAll": "oalp-idQjj",
  "popularWrapper": "oalp-cWARx"
};
import { FormattedMessage as Translation } from 'react-intl';
export var BrandsWidget = function BrandsWidget(_ref) {
  var router = _ref.router,
    _ref$data = _ref.data,
    title = _ref$data.title,
    popular_list = _ref$data.popular_list,
    metadata = _ref.metadata;
  function handleShowAllTap() {
    router === null || router === void 0 ? void 0 : router.push('/valuation/make');
  }
  var _ref2 = metadata || {},
    widgetStyle = _ref2.style;
  return /*#__PURE__*/React.createElement("div", {
    style: widgetStyle
  }, /*#__PURE__*/React.createElement("div", {
    style: title === null || title === void 0 ? void 0 : title.style
  }, title === null || title === void 0 ? void 0 : title.text), /*#__PURE__*/React.createElement("div", {
    className: css.popularWrapper
  }, popular_list && popular_list.map(function (_ref3) {
    var icon = _ref3.icon,
      key = _ref3.key,
      label = _ref3.label;
    function handleBrandTap() {
      var userValuation = getEvaluationObject({
        make: key,
        'make-displayValue': label
      });
      UserSession.saveValuationDataValues(userValuation);
      UserSession.saveUserEvaluationFormValues(userValuation, false);
      router === null || router === void 0 ? void 0 : router.push('/valuation-flow');
    }
    return /*#__PURE__*/React.createElement("div", {
      className: css.popularField,
      onClick: handleBrandTap
    }, /*#__PURE__*/React.createElement("img", {
      src: icon,
      width: "56",
      height: "28"
    }));
  }), /*#__PURE__*/React.createElement("div", {
    className: css.showAll,
    onClick: handleShowAllTap
  }, /*#__PURE__*/React.createElement(Translation, {
    id: "showAll"
  }))));
};
export default withRouter(BrandsWidget);